/* DVR 07/10/2026 - O BOTAO "FEMININA (BABY LOOK)" PASSA A LEVAR PARA O PRODUTO.

   Ate aqui a baby look nao era um produto: era uma propriedade de linha. O
   botao so repintava a tela e o carrinho recebia "Modelagem: Baby look" em
   cima da variante da camiseta unissex. Por isso a miniatura do carrinho vinha
   errada e a peca feminina nao existia para o Google.

   Agora cada arte tem o seu baby-<base>, com foto propria, e o botao tem que
   navegar, igual o oversized ja faz.

   Por que aqui e nao dentro do vf-molde.js: aquele arquivo tem 32 KB e nao
   existe edicao parcial em tema, cada virgula obriga a reenviar os 32 KB. O
   motor ja monta os botoes e ja trata o clique lendo data-ir NA HORA do
   clique, entao basta carimbar o data-ir depois que ele montou.

   Por que o endereco sai de uma consulta e nao do Liquid: a secao so sabe
   derivar oversized- a partir de camisa- e camiseta-. Ensinar ela a conhecer
   baby- obrigaria a reescrever o arquivo inteiro da secao. Aqui a consulta e
   uma so por pagina, assincrona, e serve de conferencia: se o produto nao
   existir ou estiver sem estoque, o botao fica como estava.

   Para desfazer: apague a linha que carrega este arquivo no scripts.liquid.
   Nenhum motor foi tocado.
*/
(function () {
  var PREFIXOS = ['oversized-', 'camiseta-', 'camisa-', 'baby-'];

  function handleAtual() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function parte(h) {
    for (var i = 0; i < PREFIXOS.length; i++) {
      if (h.indexOf(PREFIXOS[i]) === 0) {
        return { pre: PREFIXOS[i], base: h.slice(PREFIXOS[i].length) };
      }
    }
    return null;
  }

  var cache = {};
  function endereco(h) {
    if (!cache[h]) {
      cache[h] = fetch('/products/' + h + '.js', { headers: { accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { return (j && j.available) ? '/products/' + h : ''; })
        .catch(function () { return ''; });
    }
    return cache[h];
  }

  function todos() { return document.querySelectorAll('.vfm-mod'); }

  function acha(nome) {
    var bs = todos();
    for (var i = 0; i < bs.length; i++) {
      if (bs[i].getAttribute('data-m') === nome) return bs[i];
    }
    return null;
  }

  /* o motor so amarra o clique em botao que nasceu habilitado. Quando eu
     acendo um que nasceu morto, ele fica sem tratador, entao levo eu mesmo. */
  function escolhido(sel) {
    var e = document.querySelector(sel + '.on') || document.querySelector(sel + '.ativo');
    if (!e) return '';
    return (e.getAttribute('data-v') || e.getAttribute('data-l') || e.getAttribute('data-c') ||
            e.getAttribute('title') || e.textContent || '').trim();
  }

  function leva(url, mod) {
    try {
      localStorage.setItem('dvr:abre', JSON.stringify({
        mod: mod,
        loc: escolhido('.vf-loc'),
        cor: escolhido('.vf-cor'),
        t: Date.now()
      }));
    } catch (e) {}
    location.href = url;
  }

  var SIGLA = { 'Unissex': 'uni', 'Baby look': 'bab', 'Oversized': 'ove' };

  function acende(b, url) {
    if (!b || !url) return;
    var estavaMorto = b.disabled || b.classList.contains('vfm-off');
    b.setAttribute('data-ir', url);
    b.classList.remove('vfm-off');
    b.removeAttribute('disabled');
    b.removeAttribute('aria-disabled');
    var em = b.querySelector('em');
    if (em && em.textContent.trim().toLowerCase() === 'em breve' && b.getAttribute('data-med')) {
      em.textContent = b.getAttribute('data-med');
    }
    if (estavaMorto && !b.dataset.dvrLig) {
      b.dataset.dvrLig = '1';
      b.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        leva(b.getAttribute('data-ir'), SIGLA[b.getAttribute('data-m')] || 'uni');
      });
    }
  }

  var alvos = null;   /* {Unissex:url, 'Baby look':url, Oversized:url} */
  var ehBaby = false;
  var cliques = 0;   /* o motor remonta e volta a acender o Unissex; algumas
                        tentativas resolvem sem virar pingue-pongue */

  function aplicar() {
    if (!alvos) return;
    var bs = todos();
    if (!bs.length) return;
    for (var i = 0; i < bs.length; i++) {
      var b = bs[i];
      var nome = b.getAttribute('data-m');
      var u = alvos[nome];
      if (u) {
        if (b.getAttribute('data-ir') !== u) acende(b, u);
      } else if (ehBaby && nome === 'Baby look') {
        b.removeAttribute('data-ir');
      }
    }
    if (ehBaby) {
      var bb = acha('Baby look');
      if (bb && !bb.classList.contains('on') && cliques < 8) {
        cliques++;
        bb.click();
      }
    }
  }

  function descobre() {
    var h = handleAtual();
    if (!h) return;
    var p = parte(h);
    if (!p) return;
    ehBaby = (p.pre === 'baby-');
    alvos = {};
    if (!ehBaby) {
      endereco('baby-' + p.base).then(function (u) { alvos['Baby look'] = u; aplicar(); });
      return;
    }
    endereco('camisa-' + p.base).then(function (u) {
      return u ? u : endereco('camiseta-' + p.base);
    }).then(function (u) { alvos['Unissex'] = u; aplicar(); });
    endereco('oversized-' + p.base).then(function (u) { alvos['Oversized'] = u; aplicar(); });
  }

  /* o motor remonta a barra quando a pessoa troca cor, tamanho ou local, e a
     remontagem apaga o data-ir. Por isso o carimbo e reaplicado, nao feito uma
     vez so. */
  function vigia() {
    if (!window.MutationObserver) return;
    var pendente = null;
    new MutationObserver(function () {
      if (pendente) return;
      pendente = setTimeout(function () { pendente = null; aplicar(); }, 60);
    }).observe(document.documentElement, { subtree: true, childList: true });
  }

  function iniciar() {
    descobre();
    vigia();
    aplicar();
    var n = 0;
    var t = setInterval(function () {
      aplicar();
      if (++n > 40) clearInterval(t);
    }, 250);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  window.addEventListener('load', aplicar);
})();
